export const italianPlate = {
  fontFamily: "Italian Plate No2 Expanded",
  src: `url(https://static.afterpay.com/font/ItalianPlateNo2Expanded-Regular.woff)
  format("woff");
  `,
};
